import { render, staticRenderFns } from "./EditUserCommissions.vue?vue&type=template&id=52dfa6e2&scoped=true&"
import script from "./EditUserCommissions.vue?vue&type=script&lang=ts&"
export * from "./EditUserCommissions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52dfa6e2",
  null
  
)

export default component.exports